{
  "common": {
    "productNoun": {
      "form": "lomake",
      "survey": "kysely",
      "quiz": "tietokilpailu"
    },
    "productNounCapitalized": {
      "form": "Lomake",
      "survey": "Kysely",
      "quiz": "Tietovisa"
    },
    "urlField": {
      "settingsTitle": "Määritä URL-kentän asetukset",
      "description": "Valitse, mitkä URL-tyypit ovat sallittuja tässä kentässä.",
      "allowAllDomains": "Salli kaikki verkkotunnukset",
      "allowAllDomainsDescription": "Any valid URL is accepted.",
      "allowOnlyDomains": "Salli vain nämä verkkotunnukset",
      "allowOnlyDomainsDescription": "Everything else is rejected.",
      "blockDomains": "Estä nämä verkkotunnukset",
      "blockDomainsDescription": "Everything else is accepted.",
      "domainsAllowed": "Sallitut verkkotunnukset",
      "domainsBlocked": "Estetyt verkkotunnukset",
      "domainPlaceholder": "esim. example.com",
      "domainPlaceholderAdd": "Lisää toinen",
      "domainHint": "Kirjoita verkkotunnus ja lisää se painamalla Enter.",
      "invalidDomain": "Anna oikeassa muodossa oleva verkkotunnus ilman http://-, https://- tai polkumäärityksiä.",
      "domainRequired": "Lisää vähintään yksi verkkotunnus tälle vaihtoehdolle.",
      "singleUrlInfo": "Yhteen kenttään voi lisätä vain yhden URL-osoitteen. Jos haluat lisätä useita URL-osoitteita, luo niille erilliset kentät."
    },
    "px": "pikseliä",
    "px_uppercase": "PX",
    "seconds": "sekuntia",
    "other": "-- Muu --",
    "customFieldExistsError": "Tämänniminen Mukautettu Kenttä on jo luotu",
    "requiredField": "Tämä kenttä on pakollinen",
    "uniqueKeyNotUniqueError": "Tämä Avain- ei ole ainutlaatuinen",
    "save": "Tallenna",
    "saving": "Tallennetaan",
    "typeAnOption": "Kirjoita vaihtoehto",
    "unsaved": "Tallentamaton",
    "noSubmissionsFound": "Lähetyksiä ei löytynyt",
    "sortBy": "Lajitteluperuste:",
    "clearAll": "Tyhjennä kaikki",
    "submitSurvey": "Lähetä kysely",
    "select": "Valitse",
    "data": "data",
    "enterAmount": "Anna summa",
    "disqualifyAfterSubmitLower": "Hylkää lähettämisen jälkeen",
    "errorRetryAgain": "Virhe, yritä uudelleen",
    "savedSuccessfully": "Tallennus onnistui!",
    "couldntSaveChanges": "Muutosten tallentaminen ei onnistunut. Yritä uudelleen.",
    "emailNotificationSettingsUpdated": "Sähköposti-ilmoitusten asetukset on päivitetty.",
    "autoResponderSettingsUpdated": "Automaattisen vastaajan asetukset on päivitetty.",
    "bubbleRadioStyleImageAlt": "Valintanapin kuplatyyli",
    "standardRadioStyleImageAlt": "Valintanapin vakiotyyli",
    "recurringFrequency": {
      "once": "Kerran",
      "daily": "Päivittäin",
      "weekly": "Viikoittain",
      "monthly": "Kuukausittain",
      "yearly": "Vuosittain"
    },
    "saveExitConfirmationSubText": "Näytä vahvistusikkuna, kun käyttäjä poistuu sivulta.",
    "yes": "Kyllä",
    "no": "Ei",
    "updated": "Päivitetty",
    "new": "Uusi",
    "title": "Otsikko",
    "openSettings": "Avaa asetukset",
    "cloneField": "Kloonaa kenttä",
    "removeField": "Poista kenttä",
    "description": "Kuvaus",
    "cannotAddThisField": "Tätä kenttää ei voi lisätä",
    "overallOnly": "Yleisesti vain",
    "nextSlideDefault": "Seuraava dia (oletus)",
    "nextQuestion": "Seuraava kysymys",
    "searchAddress": "Etsi osoite",
    "recurringDonation": "Toistuva lahjoitus",
    "recurringDonationDay": "Toistuva lahjoitus 1 päivän ajan",
    "recurringDonationWeek": "Toistuva lahjoitus 1 kerran viikossa",
    "recurringDonationMonth": "Toistuva lahjoitus 1 kuukausi",
    "recurringDonationYear": "Toistuva lahjoitus 1 vuosi",
    "integrate": "Integroi",
    "preview": "Esikatselu",
    "back": "Takaisin",
    "alert": "Ilmoitus",
    "proceed": "Jatka",
    "confirm": "Vahvista",
    "cancel": "Peruuta",
    "delete": "Poista",
    "embed": "Upota",
    "link": "Linkitä",
    "linkModal": {
      "title": "Lisää linkki",
      "urlLabel": "URL",
      "urlPlaceholder": "https://www.esimerkki.fi",
      "invalidUrl": "URL-osoite on virheellinen"
    },
    "iframeEmbed": "Iframe-upotus",
    "styles": "Tyylit",
    "options": "Vaihtoehdot",
    "quickAdd": "Pikalisäys",
    "customFields": "Mukautetut kentät",
    "addObjectFields": "Lisää objektikentät",
    "personalInfo": "Henkilökohtaiset tiedot",
    "contactInfo": "Yhteystiedot",
    "submit": "Lähetä",
    "address": "Osoite",
    "customized": "Mukautettu",
    "layout": "Asettelu",
    "showLabel": "Näytä tunniste",
    "showImage": "Näytä kuva",
    "imageLayout": "Kuvan asettelu",
    "imageLayoutSettings": "Kuvan asettelun asetukset",
    "imageLayoutMode": "Kuvan asettelun tila",
    "surveyDefault": "Kyselyn oletusarvo",
    "independent": "Itsenäinen",
    "image": "Kuva",
    "desktop": "Työpöytä",
    "mobile": "Mobiili",
    "desktopImage": "Työpöytäkuva",
    "mobileImage": "Mobiilikuva",
    "uploaded": "Ladattu",
    "changeImage": "Vaihda kuva",
    "uploadImage": "Lataa kuva",
    "remove": "Poista",
    "background": "Tausta",
    "buttonBackground": "Painike Tausta",
    "gradient": "Liukuva",
    "type": "Tyyppi",
    "linear": "Lineaarinen",
    "radial": "Säteittäinen",
    "angular": "Kulmikas",
    "angle": "Kulma",
    "stops": "Pysähtyy",
    "startColor": "Aloitusväri",
    "endColor": "Lopetusväri",
    "addColor": "Lisää väri",
    "fontColour": "Fontin väri",
    "textFontColour": "Tekstin fontin väri",
    "subTextFontColour": "Alatekstin fontin väri",
    "selectThemes": "Valita Teema",
    "selectOne": "Valitse yksi",
    "enableIcon": "Ota kuvake käyttöön",
    "iconType": "Kuvaketyyppi",
    "iconPlacement": "Kuvakkeen sijoittelu",
    "filled": "Täytetty",
    "textOnly": "Vain Runko",
    "border": "Reunaviiva",
    "borderType": "Reunaviivan tyyppi",
    "cornerRadius": "Kulman pyöristyssäde",
    "width": "Leveys",
    "padding": "Reunatila",
    "top": "Ylä",
    "bottom": "Ala",
    "left": "Vasen",
    "right": "Oikea",
    "center": "Keskittää",
    "default": "Oletus",
    "formDefault": "Lomakkeen oletus",
    "shadow": "Varjo",
    "color": "Väri",
    "horizontal": "Vaakasuuntainen",
    "vertical": "Pystysuuntainen",
    "blur": "Epäterävyys",
    "spread": "Hajaantuvuus",
    "fieldStyle": "Kentän tyyli",
    "fontColor": "Fontin väri",
    "inputTextFillColor": "Syötetekstin täyttöväri",
    "inputTextColor": "Syötteen tekstin väri",
    "primaryColor": "Ensisijainen väri",
    "primaryColorTooltip": "Hallinnoi hiiritilan ja dynaamisen tilan väriä.",
    "primaryColorTooltipLearnMore": "Lue lisää",
    "inputTextColorTooltip": "Hallinnoi syöttökenttiin kirjoitetun tekstin väriä.",
    "mapPrimaryColorToButtonColor": "Kartoita ensisijainen väri painikkeen väriin",
    "label": "Tunniste",
    "fontFamily": "Fonttiperhe",
    "size": "Koko",
    "weight": "Paino",
    "fontWeightTooltip": "Sovellettavissa kappaleiden tapauksessa",
    "fontWeightOptions": {
      "thin": "100 – ohut",
      "extraLight": "200 – erittäin kevyt",
      "light": "300 – kevyt",
      "normal": "400 – normaali",
      "medium": "500 – keskikokoinen",
      "semiBold": "600 – puolilihavoitu",
      "bold": "700 – lihavoitu"
    },
    "placeholder": "Paikkateksti",
    "customCSS": "Mukautettu CSS",
    "backgroundImage": "Taustakuva",
    "headerImage": "Pääkuva",
    "miscellaneous": "Muut",
    "agencyBranding": "Yrityksen brändi-ilme",
    "imageUploadMessage": "Lataa kuvatiedosto napsauttamalla tästä tai vetämällä kuva tähän",
    "backgroundImageTooltipMessage": "Taustakuvan on tarkoitus kattaa koko sivu ja toimia visuaalisesti miellyttävänä taustana lomakkeelle. Napsauttamalla \"Esikatselu\" voit tarkistaa, miltä taustakuva näyttää.",
    "headerImageTooltipMessage": "Pääkuva on suunniteltu mukautumaan lomakkeen leveyteen ja pysymään lomakkeen yläreunassa. Napsauttamalla \"Esikatselu\" voit tarkistaa, miltä pääkuva näyttää.",
    "onSubmit": "Lähettämisen yhteydessä",
    "facebookPixelID": "Facebook Pixel ‑tunnus",
    "facebookPixelFunnelLabel": "Käytetäänkö tätä suppilon sisällä?",
    "facebookPixelFunnelText": "Jätä se tyhjäksi – suppilon oma pikseli ja evästeiden suostumusasetukset tulevat käyttöön.",
    "facebookPixelEmbedLabel": "Upotetaanko toiselle sivustolle?",
    "facebookPixelEmbedText": "Valitse, miten evästeiden suostumus käsitellään koodin upotusvaiheessa.",
    "facebookPixelConsentCallout": "Evästeiden suostumus asetetaan upotuksittain kohdassa",
    "facebookPixelConsentCalloutLink": "Integroi → Upota koodi",
    "facebookPixelEvents": "Facebook Pixel ‑tapahtumat",
    "onpageView": "Sivun katselun yhteydessä",
    "stickyContact": "Tallennettu kontakti",
    "stickyContactMessage": "Muistaa ja täyttää yhteystiedot automaattisesti, kun käyttäjä palaa samalle laitteelle ja selaimelle.",
    "generateSubmissionDocument": "Laadi lähetysasiakirja",
    "generateSubmissionDocumentMessage": "Luo automaattisesti tulostettava PDF-tiedosto jokaisesta lähetyksestä ja liitä se kontaktin asiakirjoihin",
    "saveQuizSubmissionAsPdf": "Tallenna kyselyn vastauslähetys PDF-tiedostona",
    "saveQuizResultAsPdf": "Tallenna kyselyn tulos PDF-muodossa",
    "showSubmissionInConversationsFeed": "Luo keskustelu lähetyksen yhteydessä",
    "showSubmissionInConversationsFeedMessage": "Luo automaattisesti keskusteluketju, kun tämä lomake lähetetään, jolloin voit seurata sähköpostitse, tekstiviestitse tai muilla kanavilla Keskustelut-välilehden kautta.",
    "fieldDescription": "Kentän kuvaus",
    "fieldTitle": "Kentän otsikko",
    "queryKey": "Kyselyavain",
    "querykeyTooltipMessage": "Kyselyavain, jota voidaan käyttää URL-parametrina tämän kentän täyttämisessä",
    "required": "Pakollinen",
    "hidden": "Piilotettu",
    "hiddenValue": "Piilotettu arvo",
    "enableCountryPicker": "Ota maavalitsin käyttöön",
    "altText": "Alt-teksti",
    "optionImageAlt": "Vaihtoehdon kuva",
    "bannerAlt": "banneri",
    "avatarAlt": "Avatar-nimi",
    "alignment": "Tasaus",
    "imageWidth": "Kuvan leveys",
    "imageHeight": "Kuvan korkeus",
    "logic": "Logiikka",
    "pleaseInput": "Lisää",
    "editHTML": "Muokkaa HTML:ää",
    "textStyle": "Tekstin tyyli",
    "subText": "Alateksti",
    "text": "Teksti",
    "buttonStyle": "Painikkeen tyyli",
    "fullWidth": "Täysi leveys",
    "htmlMessage": "Lisää mukautettu HTML-koodi tähän",
    "htmlEditorHeader": "MUKAUTETTU JAVASCRIPT/HTML",
    "htmlEditorBodyMessage": "Lisää oma koodi tähän",
    "scriptAdded": "Skripti lisätty!",
    "sourceAddedForm": "Lähde \"Lomakkeen nimi\"",
    "sourceAddedSurvey": "Lähde \"Kyselyn nimi\"",
    "sourceAddedQuiz": "Lähde \"Tietovisan nimi\"",
    "yesSave": "Kyllä, tallenna",
    "cancelKeep": "Peruuta, säilytä",
    "done": "Valmis",
    "addElement": "Lisää elementti",
    "addUrlLike": "Lisää kelvollisia URL-osoitteita, kuten",
    "doNotAddRelativePath": "Älä lisää suhteellisia polkuja, esim.",
    "or": "tai",
    "addCustomFields": "Lisää mukautettuja kenttiä",
    "customFieldSearch": "Search by name",
    "selectedCount": "{count} valittu",
    "noFieldsFound": "Kenttiä ei löytynyt",
    "noFieldsMatchQuery": "Yksikään kenttä ei vastaa hakua {query}. Kokeile toista termiä tai luo uusi kenttä.",
    "clearSearch": "Tyhjennä haku",
    "addFieldWithCount": "Lisää {count} kenttä | Lisää {count} kenttää",
    "noFieldsYet": "Ei vielä kenttiä",
    "noFieldsForObject": "Tässä objektissa ei ole vielä yhtään kenttää. Aloita luomalla sellainen.",
    "createField": "Luo kenttä",
    "enterSourceValue": "Anna lähdearvo",
    "shortLabel": "Lyhyt tunniste",
    "shortLabelPlaceholder": "Fontti a Lyhyt tunniste",
    "labelPlaceholder": "Kirjoita Kirjoittaa",
    "imagePlaceholder": "Kuva",
    "fillValuesPlaceholder": "Lisää arvoja",
    "customCSSTooltip": "Mukautettu CSS ohittaa lomakkeen tyylivalinnat ja teemat, ja sillä voi olla vaikutusta teeman tyyliin.",
    "fontFamilyTooltip": "Editointityökalu tukee kaikentyyppisiä fontteja, jos et näe etsimääsi luettelossa. Hae sitä pudotusvalikosta",
    "angleTooltip": "Säätää liukuman suuntaa. 0° on oikealle, 90° on alaspäin, 180° on vasemmalle, 270° on ylöspäin.",
    "useGDPRCompliantFont": "Käytä GDPR-yhteensopivaa fonttia",
    "enableTimezone": "Ota aikavyöhyke käyttöön",
    "inputStyle": "Syötekentän tyyli",
    "conditionalLogicAlertOnSubmit": "Ehdollinen logiikka ohittaa täällä olevan viestin/uudelleenohjauksen",
    "conditionalLogicAlertOnShowHide": "Ehdollinen logiikka ohittaa täällä olevat piilotetut asetukset",
    "placeholderFacebookPixelIdInput": "Lisää Facebook Pixel ‑tunnus",
    "doNotShowMessage": "Älä näytä enää",
    "creatingForm": "Luotu Lomake...",
    "creatingSurvey": "Luotu Kyselysi...",
    "creatingQuiz": "Luo tietovisasi...",
    "errorCreatingForm": "ilmestyi virhe Luotu your Lomake. Ole hyvä ja Yrittää uudelleen.",
    "errorCreatingSurvey": "esiintyi virhe Luotu your Kysely. Ole hyvä ja Yrittää uudelleen.",
    "errorCreatingQuiz": "ilmestyi virhe Luotu tietovisasi. Ole hyvä ja Yrittää uudelleen.",
    "redirectMessage": "Sinut uudelleenohjataan kohteeseen:",
    "themes": {
      "themes": "Teemat",
      "alertThemeMessage": "Teeman vaihtaminen johtaa kaikkien nykyisten tyylimuutosten menettämiseen.",
      "useTheme": "Käytä teemaa",
      "removeTheme": "Poista teema"
    },
    "box": "Laatikko",
    "line": "Rivi",
    "message": "Viesti",
    "openUrl": "Uudelleenohjaa URL-osoitteeseen",
    "borderTypeList": {
      "dotted": "Pisteviiva",
      "dashed": "Katkonainen",
      "solid": "Yhtenäinen",
      "none": "Ei mitään"
    },
    "button": "Painike",
    "emailNotification": "Sähköposti-ilmoitukset",
    "emailNotificationSubheader": "Saat sähköpostiviestin, kun joku täyttää lomakkeesi",
    "subject": "Aihe",
    "emailTo": "Sähköposti (vastaanottaja)",
    "senderName": "Lähettäjän nimi",
    "senderNameWarning": "(Alitilinimesi) lisätään, jos kohta on jätetty tyhjäksi",
    "emailError": "Vähintään yksi sähköpostiosoite vaaditaan",
    "emailTooltip": "Anna yksi tai useampi sähköpostiosoite, jotka saavat tämän lomakkeen lähetysilmoituksen. Ensimmäinen osoite menee kohtaan \"Vastaanottaja\"; muita osoitteita käsitellään nimellä \"CC\".",
    "emailTooltipForm": "Anna yksi tai useampi sähköpostiosoite, jotka saavat tämän lomakkeen lähetysilmoituksen. Ensimmäinen osoite menee kohtaan \"Vastaanottaja\"; muita osoitteita käsitellään nimellä \"CC\".",
    "emailTooltipSurvey": "Anna yksi tai useampi sähköpostiosoite, jotka saavat tämän kyselyvastauksen lähetysilmoituksen. Ensimmäinen osoite menee kohtaan \"Vastaanottaja\"; muita osoitteita käsitellään nimellä \"CC\".",
    "emailTooltipQuiz": "Anna yksi tai useampi sähköpostiosoite, jotka saavat vastaanottaa tämän tietovisan lähetysilmoituksen. Ensimmäinen osoite menee kohtaan \"Vastaanottaja\"; muita osoitteita käsitellään nimellä \"CC\".",
    "clear": "Tyhjennä",
    "filter": "Suodata",
    "noResults": "Ei tuloksia",
    "search": "Hae",
    "showNotificationsSettings": "Näytä ilmoitusasetukset",
    "emailServicePaid": "Tämä ominaisuus on maksullinen palvelu, ja siitä veloitetaan käytön mukaan.",
    "integration": "Integraatio",
    "validation": {
      "fieldRequired": "Kenttä on Pakollinen",
      "maxLengthExceeded": "Maksimi Pituus ylitetty ({max} Merkki)"
    },
    "securityValidation": {
      "title": "Tietoturvaongelmia on havaittu. Seuraavat eivät ole sallittuja:",
      "cookieAccess": "Evästeiden käyttö havaittu (document.cookie). Tämä ei ole sallittua turvallisuussyistä.",
      "storageAccess": "localStorage.getItem() - lukeminen localStoragesta ei ole sallittua.",
      "evalUsage": "eval()-funktion käyttö ei ole sallittua, koska se voi suorittaa mielivaltaista koodia.",
      "dynamicFunction": "Dynaamisten funktioiden luominen (new Function) ei ole sallittua turvallisuussyistä.",
      "stringExecution": "Merkkijonojen välittäminen funktioille setTimeout/setInterval ei ole sallittua, koska se voi suorittaa mielivaltaista koodia. Käytä sen sijaan funktioviittauksia.",
      "unclosedTag": "Havaittiin sulkematon HTML-tunniste (esimerkiksi <style> ilman sulkevaa </style>-tunnistetta). Sulje kaikki tunnisteet ennen tallentamista, muuten julkaistun sivun lataaminen saattaa epäonnistua."
    },
    "products": {
      "subscriptionBadge": "Tilaus",
      "trialBadge": "{days} päivän ilmainen kokeilu",
      "setupFee": "Kertaluonteinen määritysmaksu",
      "quantity": "Määrä",
      "productImageAlt": "Tuotekuva",
      "bumpIconAlt": "Lisävalinta-kuvake"
    },
    "payment": {
      "payments": "Maksut",
      "paymentProviders": "Maksupalveluntarjoajat",
      "paymentProvidersDescription": "Yhdistä maksupalveluntarjoaja, jotta voit hyväksyä maksuja.",
      "connectedProviders": "Yhdistetyt palveluntarjoajat",
      "requireCreditCard": "Vaadi kortti 0 $:n tilauksissa",
      "requireCreditCardTooltip": "Kun tämä on käytössä, asiakkaiden on annettava luottokorttitiedot myös 0 $ ostoksille.",
      "connectProviders": "Yhdistä palveluntarjoajat",
      "loading": "Ladataan...",
      "generalTab": "Yleinen",
      "productTab": "Tuote",
      "connected": "Yhdistetty",
      "connect": "Yhdistä",
      "liveModeOn": "Live-tila",
      "status": "Tila",
      "test": "Testaa",
      "live": "Julkaistu",
      "paymentFields": "Maksukentät",
      "suggestAnAmount": "Ehdota summaa",
      "recurringPayments": "Toistuvat maksut",
      "selectCurrency": "Valitse valuutta",
      "tagActiveBGColor": "Aktiivisen tunnisteen väri",
      "includeOtherAmount": "Sisällytä muu summa",
      "footerInfo": "Alatunnisteen tiedot",
      "paymentType": "Maksutyyppi",
      "sellProducts": "Myy tuotteita",
      "customAmount": "Muu summa",
      "collectPayment": "Peri maksu",
      "generalSettings": "Yleiset kentät",
      "securePayments": "*100 % Lukita ja turvalliset maksut*",
      "error": {
        "addMainProductFirst": "Lisätä a ENSISIJAINEN tuote ensin",
        "priceNotFoundForBumpProduct": "Hinta ei löydetty kohteelle Lisämyyntituote",
        "productAlreadyAdded": "Tuote on jo lisätty"
      },
      "product": {
        "addProduct": "Lisää tuote",
        "productSettings": "Tuotteen asetukset",
        "bumpTag": "Lisävalinta",
        "settingsAria": "Tuoteasetukset",
        "deleteAria": "Poista tuote",
        "selectProduct": "Valitse tuote",
        "editThisProduct": "Jos haluat muokata tätä tuotetta",
        "clickHere": "Napsauta tästä",
        "show": "Näytä",
        "description": "Kuvaus",
        "image": "Kuva",
        "layoutSettings": "Asettelun asetukset",
        "singleColumn": "Yksi sarake",
        "twoColumn": "Kaksi saraketta",
        "threeColumn": "Kolme saraketta",
        "maxProductError": "Yhdellä lomakkeella saa olla enintään 20 tuotetta",
        "productSelectPlaceholder": "Valitse tuote",
        "orderConfirmation": "Tilausvahvistus",
        "orderConfirmationWarning": "Tilauksen vahvistussivu tulee näkyviin, kun maksu on onnistunut",
        "quantity": "Määrä",
        "createProduct": "Jos haluat luoda tuotteen",
        "noProductsAdded": "Tuotteita ei ole vielä lisätty",
        "productsWillShowHere": "Kun Sinä/Te Sisällyttää tuotteet, ne nousevat oikein tässä",
        "chooseProductType": "Valita Tuotteen Kirjoittaa",
        "mainProduct": "ENSISIJAINEN Tuote",
        "primaryOffer": "Ensisijainen tarjous",
        "checkoutAddOn": "Kassan lisäosa",
        "pricingOptions": "Hinnoitteluvaihtoehdot",
        "pricingOptionsPlaceholder": "Valitse hinnoitteluvaihtoehdot (oletusarvo: kaikki)",
        "all": "KAIKKI",
        "addOrSelectProducts": "Lisää tai valitse tuotteita",
        "onceYouAddProductsTheyWillShowUpRightHere": "Kun lisäät tuotteita, ne näkyvät tässä",
        "addProducts": "Lisää tuotteita"
      },
      "bumProduct": {
        "price": "Hinta",
        "variant": "Variantti",
        "headline": "Otsikko",
        "otoHeadline": "OTO Otsikko",
        "otoText": "OTO Runko",
        "enableImage": "Ota Kuva Ottaa käyttöön",
        "imageMessage": "Hankimme Oletus Tuote Kuvan",
        "orUploadADifferentImage": "Tai Ladata eri Kuva",
        "bumpProducts": "Bump-tuotteet",
        "bumpProduct": "Lisämyyntituote",
        "enableBump": "Ota Bump Ottaa käyttöön",
        "orderBumpStyle": "Tilauksen lisätarjous Tyyli",
        "classic": "Klassinen",
        "modern": "Moderni",
        "icon": "Kuvake",
        "bumpTemplate": "Valita Mallipohja",
        "highlightText": "Korostaa Runko",
        "showPrice": "Näyttää Hinta",
        "bumpPriceColor": "Hinta",
        "bumpIconColor": "Kuvake",
        "bumpBackgroundColor": "Bump Tausta",
        "highlightTextColor": "Korostaa Runko",
        "headlineColor": "Otsikko",
        "otoHeadlineColor": "OTO Otsikko",
        "otoTextColor": "OTO Runko",
        "bumpBorderColor": "Bump Reuna",
        "priceRequired": "Hinta on Pakollinen",
        "headlineRequired": "Otsikko on Pakollinen",
        "otoHeadlineRequired": "OTO-otsikko on pakollinen",
        "otoTextRequired": "OTO-teksti on pakollinen",
        "bumpProductTooltip": "Kassan aikana tarjottu Pieni Lisäosa Kertoa Järjestää Arvolle. asiakkaiden voi sisällyttää sen Yksilöllisellä napsauttaalla.",
        "templateOne": "Mallipohja 1",
        "templateTwo": "Mallipohja 2",
        "templateThree": "Mallipohja 3",
        "animationIcon": {
          "none": "Ei mitään",
          "arrow": "Nuoli",
          "fire": "Tulipalo",
          "plus": "Plus",
          "giftBox": "Laatikko",
          "timer": "Lähtölaskenta",
          "cracker": "Cracker",
          "snack": "Välipala",
          "partyBalloon": "Juhlan ilmapallo",
          "flash": "Flash",
          "money": "Valuutta",
          "spaceShuttle": "Tyhjä tila"
        }
      },
      "coupons": {
        "coupons": "Kupongit",
        "enableCoupon": "Ota kuponki käyttöön",
        "couponAlignment": "Kupongin tasaus",
        "left": "Vasen",
        "right": "Oikea",
        "fullWidth": "Täysi leveys",
        "tooltipMessage": "Valitse kupongin syötekohdan sijoitus alla olevista tyypeistä"
      }
    },
    "addressSettings": {
      "autoComplete": "Täydennä osoite automaattisesti",
      "addressfields": "Osoitekentät",
      "placeholderSearch": "Hae osoitetta",
      "autoCompleteTooltip": "Tämän ominaisuuden avulla osoite voidaan hakea ja täyttää automaattisesti.",
      "streetAddress": "Osoite",
      "autoCompleteAddressTitle": "Automaattinen Suorittaa Osoite",
      "newBadge": "uusi",
      "defaultLabel": "Osoite",
      "searchPlaceholder": "Hakea Osoite",
      "mandataorySearch": {
        "title": "Pakollinen to Valita Osoite in Barissa",
        "primaryText": "Täydennä automaattisesti vain Osoite",
        "secondaryText": "Kun Käytössä, Kun a Käyttäjä on vuorovaikutuksessa Osoite Kentän kanssa, sitten heidän on Valita voimassa oleva Osoite Edetaan.",
        "secondaryText1": "Kun Poistettu Sitten he voivat Edetä ilman Osoiten valintaa in -baarissa."
      }
    },
    "autoResponder": "Automaattinen vastaaja",
    "workflow": "Työnkulku",
    "workflowSubheader": "Automatisoi, mitä tapahtuu lomakkeen lähettämisen jälkeen",
    "workflowTitle": "Luo oma yksinkertainen työnkulku.",
    "workflowDescription": "Käytä työnkulkuja hoitamaan seurantatoimenpiteet sen jälkeen, kun yhteyshenkilöt ovat olleet vuorovaikutuksessa lomakkeesi kanssa. Esimerkiksi lähettämällä heille seurantasähköpostin tai tekstiviestin",
    "createWorkflow": "Luo työnkulku",
    "workflowVisualAlt": "Visuaalinen työnkulku",
    "autoResponderSubheader": "Lähetä automaattinen sähköpostiviesti lomakkeen lähettäneelle henkilölle (sähköpostiviesti sisältää kopion lomakkeeseen lisätyistä tiedoista)",
    "replyToEmail": "Vastausosoite",
    "open": "Avoin",
    "won": "Toteutunut",
    "lost": "Menetetty",
    "abandon": "Hylätty",
    "selectAPipeline": "Valitse prosessi",
    "stage": "Vaihe",
    "status": "Tila",
    "opportunityValue": "Mahdollisuuden arvo",
    "createNewPipeline": "Luo uusi prosessi",
    "editOpportunitySettings": "Muokkaa mahdollisuusasetuksia",
    "contact": "Kontakti",
    "opportunity": "Mahdollisuus",
    "business": "Yritys",
    "add": "Lisää",
    "manage": "Hallinnoi",
    "more": "Lisää",
    "opportunityHeading": "Miltä osin haluat päivittää mahdollisuuden?",
    "date": {
      "dateSettings": "Päivämääräasetukset",
      "dateFormat": "Päivämäärän muoto",
      "dateSeparator": "Päivämääräerotin",
      "dateFormatTooltipMessage": "Valitse päivämäärän muoto. D tarkoittaa päivää, M kuukautta ja Y vuotta",
      "dateSeparatorTooltipMessage": "Valitse erotin, joka erottaa päivän, kuukauden ja vuoden toisistaan Päivämäärän muoto ‑kohdassa valitussa muodossa.",
      "disablePicker": "Poista valitsin käytöstä"
    },
    "dateTime": {
      "tabGeneral": "Yleinen",
      "tabFieldSettings": "Kenttäasetukset",
      "collectHeading": "Valitse, mitä tämän kentän tulisi kerätä",
      "collectDate": "Päivämäärä",
      "collectTime": "Aika",
      "collectDateTime": "Päivämäärä ja kellonaika",
      "collectTypeLockedTooltip": "Keräystyyppiä voidaan muuttaa vain ennen kuin kenttä on tallennettu.",
      "placeholderTextPlaceholder": "Lisää paikkamerkkiteksti",
      "shortLabelPlaceholder": "Lisää lyhyt etiketti",
      "fieldSettingsBanner": "Määritä sallittu päivämäärä- tai aikaväli, rajoita, mitkä päivät käyttäjät voivat valita, ja valitse, miten arvo esitetään.",
      "allowedDateRange": "Sallittu päivämääräväli",
      "dateModeAny": "Mikä tahansa päivämäärä",
      "dateModeFuture": "Vain tulevat päivämäärät",
      "dateModePast": "Vain menneet päivämäärät",
      "dateModeRange": "Tietty päivämääräväli",
      "futureQuestion": "Mitä päivämääriä käyttäjät voivat valita?",
      "futureAny": "Mikä tahansa tuleva päivämäärä",
      "futureAnyDesc": "Käyttäjät voivat valita minkä tahansa päivämäärän nykyisen päivämäärän jälkeen. Esim., varaa kokous milloin tahansa ensi vuonna.",
      "futureBuffer": "Puskuriajan jälkeen",
      "futureBufferDesc": "Käyttäjät voivat valita päivämääriä vasta tietyn ajan jälkeen. Esimerkiksi: salli varaukset kolme päivää tästä päivästä eteenpäin.",
      "futureBufferSuffix": "päivää tästä päivästä lukien",
      "futureRolling": "Määritetyllä aikavälillä",
      "futureRollingDesc": "Käyttäjät voivat valita päivämääriä määritetyllä tulevalla aikavälillä. Esim. salli varaukset seuraavien 30 päivän aikana.",
      "futureRollingPrefix": "Seuraavat",
      "futureRollingSuffix": "päivää",
      "rangeLabel": "Tietty päivämääräväli",
      "rangeStart": "Alkamispäivä",
      "rangeEnd": "Päättymispäivämäärä",
      "availableDays": "Valittavissa olevat päivät",
      "allowedTimeRange": "Sallittu aikaväli",
      "timeModeAny": "Milloin tahansa",
      "timeModeRange": "Tietty aikaväli",
      "timeRangeLabel": "Tietty aikaväli",
      "timeStart": "Aloitusaika",
      "timeEnd": "Päättymisaika",
      "timeFormatLabel": "Ajan muoto",
      "timeFormat24": "24 tuntia",
      "timeFormat12": "ap.- / ip.-muoto",
      "timePlaceholder": "TT:MM",
      "defaultTimeLabel": "Oletusaika",
      "defaultTimeHelper": "Täytä etukäteen nykyinen tai mukautettu aika.",
      "defaultTimeNone": "Ei mitään",
      "defaultTimeCurrent": "Nykyinen",
      "defaultTimeCustom": "Mukautettu",
      "customTimeLabel": "Mukautettu aika",
      "customTimeError": "Anna kelvollinen aika TT:MM-muodossa.",
      "disableCalendarPopup": "Poista kalenterin ponnahdusikkuna käytöstä",
      "meridianAm": "ap.",
      "meridianPm": "ip.",
      "daysError": "Valitse vähintään yksi vapaa päivä",
      "dateRangeError": "Päättymispäivämäärän on oltava aloituspäivämääränä tai sen jälkeen",
      "timeRangeError": "Päättymisajan on oltava alkamisajan jälkeen",
      "saveBlockedTitle": "Päivämäärä- ja kellonaikakenttä on puutteellinen",
      "saveBlockedDescription": "Korjaa korostetut päivämäärän ja kellonajan validointivirheet ennen tallentamista.",
      "weekday": {
        "mon": "ma",
        "tue": "ti",
        "wed": "ke",
        "thu": "to",
        "fri": "pe",
        "sat": "la",
        "sun": "su"
      }
    },
    "restoreVersion": "Palauta versio",
    "versionHistory": "Versiohistoria",
    "errorMessage": "Virhe, yritä uudelleen",
    "version": "Versio:",
    "currentVersion": "Nykyinen versio",
    "messageStyling": "Viestin muotoilu",
    "validateEmailHeader": "Tarkista sähköpostiosoite",
    "validateEmailDescription": "Painike tulee näkyviin, kun käyttäjä lisää sähköpostiosoitteensa. Ominaisuus auttaa saamaan laadukkaita liidejä.",
    "verifyEmail": "Vahvista sähköposti",
    "validatePhoneHeader": "Tarkista puhelinnumero",
    "validatePhoneDescription": "Painike tulee näkyviin, kun käyttäjä lisää puhelinnumeronsa Ominaisuus auttaa saamaan laadukkaita liidejä.",
    "verifyPhone": "Vahvista puhelin",
    "validatePhoneWarning": "Jos haluat ottaa tekstiviestitse lähetettävän vahvistuskoodin käyttöön, varmista, että puhelinnumerosi on määritetty sijaintiasetuksissa.",
    "addAnotherTnc": "Lisää toinen käyttöehto",
    "tnc1": "Käyttöehto 1",
    "tnc2": "Käyttöehto 2",
    "deleteCaps": "POISTA",
    "deleteConfirmation": "Vahvista kirjoittamalla \"DELETE\"",
    "marginPadding": "Marginaali ja täyte",
    "style": {
      "formLayoutType": "Lomakkeen tyyppi",
      "layoutType": "Asettelutyyppi",
      "surveyType": "Kyselytyyppi",
      "oneColumn": "Yksi sarake",
      "twoColumn": "Kaksi saraketta",
      "singleLine": "Yksi rivi",
      "fieldWidth": "Kentän leveys",
      "labelAlignment": {
        "labelAlignment": "Tunnisteen tasaus",
        "labelWidth": "Tunnisteen leveys"
      },
      "fieldSpacing": "Kenttien välistys",
      "imageFieldSpacing": "Kuva ja kenttien välistys",
      "imageCornerRadius": "Kuvan kulman säde",
      "color": "väri",
      "fontColor": "Fontin väri",
      "inputBackgroundColor": "Syötteen taustaväri",
      "inputBorder": "Syötteen reuna",
      "layout": "Asettelu",
      "colorsAndBackground": "Värit ja tausta",
      "imageLayout": {
        "imageLayout": "Kuvan asettelu",
        "showImage": "Näytä kuva",
        "image": "Kuva",
        "desktop": {
          "topFixed": "Kiinteä yläosassa",
          "leftCenter": "Keskitetty vasemmalle",
          "rightCenter": "Keskitetty oikealle",
          "leftFixed": "Kiinteä vasemmalla",
          "rightFixed": "Kiinteä oikealla",
          "background": "Tausta"
        },
        "mobile": {
          "header": "Ylätunniste",
          "background": "Tausta"
        }
      },
      "focusPoint": {
        "title": "Keskipiste",
        "reset": "Nollaa",
        "noImage": "Kuvaa ei ole ladattu palvelimeen"
      },
      "advanceSettings": "Asetukset",
      "inputField": "Syötekenttä",
      "borderWidth": "Reunaviivan leveys",
      "borderColor": "Reunaviivan väri",
      "borderStyle": "Reunaviivan tyyli",
      "fontSize": "Fonttikoko",
      "fontWeight": "Fontin paksuus",
      "labelColor": "Tunnisteen väri",
      "placeholderColor": "Paikkatekstin väri",
      "shortLabelColor": "Lyhyen tunnisteen väri"
    },
    "replyToTooltip": "Määritä sähköpostiosoite, johon tämän ilmoituksen vastaukset tulisi lähettää. Käytä osoitetta {'{'}{'{'}contact.email{'}'}{'}'}, jotta vastaanottajat voivat vastata suoraan lomakkeen täyttäjälle.",
    "content": "Sisältö",
    "calculations": "Laskelmat",
    "uploadOptions": "Latausvaihtoehdot",
    "opportunitySettingsWarning": "Määritä mahdollisuusasetukset napsauttamalla Muokkaa mahdollisuusasetuksia ‑painiketta.",
    "startValue": "Aloitusarvo",
    "endValue": "Loppuarvo",
    "today": "Tänään",
    "thisWeek": "Tällä viikolla",
    "last7Days": "Viimeiset 7 päivää",
    "thisMonth": "Tässä kuussa",
    "last30Days": "Viimeiset 30 päivää",
    "question": "Kysymys",
    "createContactOnPartialSubmission": "Luo kontakti tietojen osittaisen lähettämisen yhteydessä",
    "howItWorks": "Miten se toimii?",
    "createContactOnPartialSubmissionDescription": "Viimeistele dia ja napsauta \"Seuraava\". Uusi kontakti luodaan ja tallennetaan automaattisesti.",
    "swapWarningMessageSurvey": "Vaihtoehtojen muokkaaminen tai vaihtaminen vaikuttaa tähän mukautettuun kenttään kaikkialla, missä sitä on käytetty. Se voi myös nollata ehdollisen logiikan. ",
    "swapWarningMessageForm": "Vaihtoehtojen muokkaaminen tai vaihtaminen vaikuttaa tähän mukautettuun kenttään kaikkialla, missä sitä on käytetty. ",
    "migrationWarningMessage": "Tämä toiminto on siirretty kyselyn ehdolliseen logiikkaan.",
    "optionLabel": "Vaihtoehdon tunniste",
    "calculationValue": "Laskelma-arvo",
    "addOption": "Lisää vaihtoehto",
    "addOtherOption": "Lisää vaihtoehto \"Muu\"",
    "otherOptionLabel": "Muu",
    "otherOptionPlaceholder": "Kirjoita tähän toinen vaihtoehto",
    "enableCalculations": "Ota laskelmat käyttöön",
    "allowOtherOption": "Salli muu vaihtoehto",
    "productSelectionSubtext": "Ota käyttöön Yksilöllinen Tai useampi tuotevalikoima",
    "multi": "Moni",
    "single": "Yksilöllinen",
    "productSelectionHeading": "Tuote",
    "spreadToColumns": "Levitä sarakkeisiin",
    "columns": "Sarakkeet",
    "customstyle": "Tyyli",
    "standard": "Vakio",
    "bubble": "Kupla",
    "radioStyles": {
      "standardAlt": "Valintanapin vakiotyyli",
      "bubbleAlt": "Valintanapin kuplatyyli"
    },
    "data": "Tiedot",
    "integratePopup": {
      "title": "Integroi lomake",
      "embedCode": "Upota koodi",
      "useInFunnelOrEmbedCode": "Käytä suppilossa / upota koodi",
      "iframeEmbed": "Iframe Upottaa",
      "layout": {
        "title": "Upota asettelutyyppi",
        "description": "Valitse suppiloon tai ulkoiselle verkkosivustolle upotettava asettelu",
        "allowMinimize": "Salli minimointi",
        "minimizedTitlePlaceholder": "Pienennetty otsikko",
        "leftAlignAlt": "Kohdista vasemmalle",
        "rightAlignAlt": "Kohdista oikealle"
      },
      "triggerType": "Käynnistystyyppi",
      "triggers": {
        "seconds": "sekuntia"
      },
      "activation": {
        "title": "Aktivointivaihtoehdot",
        "visit": "siirryt seuraavaan:"
      },
      "deactivation": {
        "title": "Aktivoinnin poistamisvaihtoehdot",
        "times": "kertaa"
      },
      "copyEmbedCode": "Kopioi upotuskoodi",
      "copyFormLink": "Kopioi lomakkeen linkki",
      "openFormLink": "Avaa lomakkeen linkki",
      "invalidInput": "Virheellinen syöte!",
      "funnel": {
        "funnel": "Suppilo",
        "chooseStep": "Valita a Vaihe",
        "copyCodeAndOpenFunnel": "Kopioida Koodi ja Avata Suppilo"
      },
      "share": {
        "share": "Jaa",
        "shareViaSocials": "Jakaa Kautta Socials",
        "copyLink": "Kopioi linkki"
      },
      "email": {
        "email": "Sähköposti",
        "shareViaEmail": "Jakaa Kautta sähköposti",
        "emailButton": "Sähköposti",
        "blankTemplate": "Tyhjä Mallipohja",
        "emailMarketingTemplates": "Sähköposti Markkinointimallit",
        "or": "Tai",
        "chooseTemplate": "Valitse mallipohjistasi",
        "continue": "Jatkaa"
      }
    },
    "rating": {
      "icon": "Kuvake",
      "iconAlignment": "Kuvake Kohdistaminen",
      "count": "Lukumäärä",
      "lowestRating": "Minimi- luokitus",
      "highestRating": "Maksimi-arvio",
      "iconSelectedState": "Kuvake Valittu Osavaltio",
      "iconUnselectedState": "Kuvake Osavaltio Kuvake",
      "rating": "Arvio",
      "ratingSettings": "Asetukset",
      "calculationType": {
        "calculationType": "Arkistoida Rating Kentät Mukautettu in",
        "calculationTypeTooltip": "Kun Sinä/Te Esiintymistaajuus jotain 4 - 5 tähteä, se tarkoittaa: - Absoluuttinen: 4 - 5 - Prosenttiosuus: 80 - Murto-osa: 0,8",
        "absolute": "Ehdoton",
        "percentage": "Prosenttiosuus",
        "fraction": "Murto-osa"
      }
    },
    "desktopMode": "Työpöytätila",
    "mobileMode": "Mobiilitila",
    "versions": "Vaihtoehdot",
    "advanced": "Edistynyt",
    "edit": "Muokkaa",
    "settings": "Asetukset",
    "submissions": "Lähetykset",
    "analytics": "Analytiikka",
    "notifications": "Ilmoitukset",
    "undo": "Kumoa",
    "redo": "Tee uudelleen",
    "customValues": "Mukautetut arvot",
    "pickBgFromImage": "Lisää sumennus viestiruudun taustaan. Jos valitset viestiruudulle taustavärin, se näkyy sumennetun viestiruudun päällä.",
    "pickBgFromImageTip": "Valitsee taustakuvaksi värin, jossa on suuri kontrasti. Huomautus: ei sovelleta, jos lomakkeen taustalla ei ole kuvaa.",
    "messageBackgroundBlur": "Taustan sumennus",
    "confirmationMessage": "Vahvistusviesti",
    "deleteOption": "Poistaa vaihtoehto",
    "deleteConfirmationModal": {
      "defaultDescription": "Poistetaan vaihtoehto vaikuttaa tähän Mukautettu Kenttä koko Paikatien poikki, jossa Kenttää käytetään. Haluatko varmasti Sinä/Te poistaa sen?",
      "validationMessage": "Kirjoita Poistaa Tallennaan.",
      "validationError": "Kirjoita Poistaa"
    },
    "disqualifyImmediately": "Hylkää välittömästi",
    "disqualifyAfterSubmit": "Hylkää lähettämisen jälkeen",
    "generalSettings": "Yleinen Asetukset",
    "advancedSettings": "Asetukset",
    "customFieldName": "Mukautettu Toimiala Nimi",
    "customFieldNameTooltip": "Tämä Toimiala Nimi on Mukautettu Toimiala per ainutlaatuinen.",
    "customFieldNameTooltipContact": "Näiden kenttien avulla käyttäjät voivat tallentaa lisätietoja henkilöstä, kuten liidityypin, syntymäpäivän tai ensisijaisen yhteydenottotavan.",
    "customFieldNameTooltipContactLearnMore": "Lue lisää",
    "customFieldNameTooltipOpportunity": "Näitä kenttiä käytetään seuraamaan kunkin mahdollisuuden sopimuskohtaisia tietoja, kuten budjetti tai sulkemistavoite.",
    "customFieldNameTooltipOpportunityLearnMore": "Lue lisää",
    "customFieldNameTooltipCompany": "Näiden kenttien avulla voidaan tallentaa organisaatiotason tietoja (esim. toimittajille, asiakkaille tai toimistoille), jotka on yhdistetty kontakteihin.",
    "customFieldNameTooltipCompanyLearnMore": "Lue lisää",
    "customFieldNameTooltipCustomObject": "Näiden kenttien avulla käyttäjät voivat kerätä yrityskohtaisia tietoja, kuten tietoja omaisuudesta, ajoneuvoista tai kiinteistöistä, ja integroida nämä tiedot CRM-järjestelmään.",
    "customFieldNameTooltipCustomObjectLearnMore": "Lue lisää",
    "uniqueKey": "Yksilöllinen avain",
    "uniqueKeyTooltip": "Tämä avain on mukautetun kentän järjestelmätunniste. Kun se on asetettu, sitä ei voi muuttaa.",
    "uniqueKeyTooltipLearnMore": "Lue lisää",
    "selectContactAssociation": "Valitse yhteydet, jotka sisältävät kontakteja",
    "associations": "Yhteydet",
    "createNewAssociation": "Luo uusi yhteys",
    "selectAnAssociation": "Valitse yhteys",
    "loadingAssociations": "Yhteyksiä ladataan...",
    "unknownAssociation": "Tuntematon yhteys",
    "manyToMany": "Monta monelle",
    "failedToLoadAssociations": "Yhteyksien lataaminen epäonnistui",
    "noAssociationsFound": "Yhteyksiä ei löytynyt",
    "keepThisField": "Pidä tämä kenttä",
    "association": "Yhteys",
    "customObject": "Mukautettu objekti",
    "customObjects": "Mukautetut objektit",
    "object": "Objekti",
    "editAssociation": "Muokkaa kohteen {objectName} yhteyttä",
    "editAssociationButton": "{edit} kohteen {objectName} yhteyttä {association}",
    "fields": "Kentät",
    "primaryFieldWarning": "{fieldName} on ensisijainen kohteen {objectSingular} kenttä, ja se on pakollinen kohteen {objectSingular} luomiseen ja päivittämiseen.",
    "primaryFieldTitle": "{fieldName} on pakollinen tietueen {objectSingular} luomiseen tai päivittämiseen.",
    "removeAllFields": "Poista kaikki kohteen {objectSingular} kentät",
    "customObjectsFallback": "Mukautetut objektit",
    "noneAssociation": "Ei mitään",
    "noneAssociationDescription": "Ei yhteyksiä, jotka sisältävät kontakteja (kontaktikenttiä ei ole)",
    "survey": {
      "layoutType": "Kyselytyyppi",
      "oneQuestionPerPage": "Yksi kysymys kerrallaan",
      "allQuestionsOnePage": "Useita kerralla"
    },
    "quizQuestions": "Tietovisa Tiedustelu",
    "choiceElements": "Choice Komponentit",
    "otherElements": "Muu Komponentit",
    "listEditor": {
      "prefillValueHeader": "Esitäyttää Arvo",
      "labelPlaceholder": "Tunniste",
      "valuePlaceholder": "Arvo",
      "optionRequiredError": "Vaihtoehto Kenttä on Pakollinen"
    },
    "field": "Kenttä",
    "scoreEditor": {
      "addFieldPlaceholder": "Lisätä Kenttä",
      "fieldLabel": "Kenttä",
      "numberLabel": "luku"
    },
    "fileUploadEditor": {
      "fileTypes": "Tiedosto",
      "all": "aikana",
      "pdf": "PDF",
      "docxDoc": "DOCX/DOC",
      "png": "PNG",
      "gif": "GIF",
      "jpgJpeg": "JPG/JPEG",
      "xlsCsv": "XLS/CSV"
    },
    "ok": "Ok",
    "allowMultipleFiles": "Ottaa ottaa käyttöön useita Tiedostot",
    "maxFileLimit": "Maksimi Tiedosto",
    "privacyPolicy": "Tietosuojakäytäntö",
    "termsOfService": "Ehdot – Palvelu",
    "colorPicker": {
      "brandColors": "Brändivärit",
      "defaultColors": "Oletusvärit",
      "globalCustomColors": "Yleiset mukautetut värit"
    },
    "billingFrequency": "Laskutustiheys",
    "otherAmount": "Muu määrä",
    "exampleUrlPlaceholder": "https://www.esimerkki.fi",
    "checkboxStyles": {
      "standardAlt": "Vakio valintaruudun tyyli",
      "bubbleAlt": "Kupla-valintaruututyyli"
    },
    "previewIcons": {
      "exportAlt": "Vie kuvake",
      "shipmentAlt": "Lähetyskuvake",
      "resultAlt": "Tulossivun kuvake"
    },
    "examples": {
      "sampleUrl": "https://esimerkki.com"
    },
    "showing": "Näytetään",
    "of": "/",
    "enterCouponCode": "Lisää kuponkikoodi",
    "apply": "Käytä",
    "paymentWillBeProcessed": "Maksu käsitellään heti, kun siirryt seuraavaan vaiheeseen",
    "paymentWillBeProcessedNextSlide": "Maksu käsitellään heti, kun käyttäjä siirtyy seuraavalle dialle",
    "showThisAlertToUsers": "Näytä tämä hälytys käyttäjille",
    "sixteenDigitCardNumber": "16-numeroinen kortin numero",
    "mmYy": "KK / VV",
    "cvc": "CVC",
    "threeDigitCode": "Kolminumeroinen koodi",
    "enterCardNumber": "Anna kortin numero",
    "pleaseFillRequiredFields": "Täytä kaikki pakolliset kentät!",
    "opportunitySettingsIncomplete": "Mahdollisuusasetukset ovat puutteelliset",
    "opportunitySettingsIncompleteDescription": "Tämä lomake sisältää mahdollisuuskenttiä, mutta mahdollisuusasetuksia ei ole päivitetty. Määritä mahdollisuusasetukset jatkaaksesi lomakkeen tallentamista.",
    "ariaAttributes": {
      "iconSearch": "kuvakehaku"
    },
    "alt": {
      "standardRadioStyle": "Valintanapin vakiotyyli",
      "bubbleRadioStyle": "Valintanapin kuplatyyli"
    },
    "value": "Arvo",
    "jumpTo": "Siirry kohtaan",
    "thankYouJohnDoe": "Kiitos, John Doe",
    "total": "Yhteensä",
    "urlExamples": {
      "simple": "example.com",
      "https": "https://esimerkki.com",
      "withPath": "example.com/path",
      "fullPath": "https://www.example.com/path"
    },
    "quizThankYou": "Kiitos osallistumisestasi tähän tietovisaan."
  },
  "overallScore": {
    "defaultTitle": "Kokonaispistemäärä"
  },
  "fields": {
    "quizQuestions": {
      "singleChoice": "Yksilöllinen valinta",
      "multipleChoice": "Monivalinta",
      "yesNo": "Kyllä / ei",
      "shortAnswer": "Lyhyt video Vastattu",
      "longAnswer": "Pitkä Vastattu",
      "number": "luku",
      "singleDropdown": "Yksilöllinen Pudotus-",
      "multiDropdown": "Moni Pudotus-"
    },
    "personal": {
      "fullName": "Täysi Nimi",
      "firstName": "Etunimi",
      "lastName": "viimeisin Nimi",
      "dateOfBirth": "Päivämäärä - syntymä",
      "phone": "Puhelin",
      "email": "Gmail",
      "fullNamePlaceholder": "Anna koko nimesi",
      "firstNamePlaceholder": "Anna etunimesi",
      "lastNamePlaceholder": "Anna sukunimesi",
      "dateOfBirthPlaceholder": "PP / KK / VVVV",
      "phonePlaceholder": "+1 (555) 000-0000"
    },
    "submit": {
      "button": "Painike"
    },
    "integration": {
      "sellProducts": "Myy tuotteita",
      "collectPayment": "Kerää Maksu"
    },
    "address": {
      "address": "Osoite",
      "streetAddress": "Osoite",
      "city": "Kaupunki",
      "state": "Osavaltio",
      "country": "Maa",
      "postalCode": "Koodi",
      "organization": "Ryhmä",
      "website": "Verkkosivusto",
      "websitePlaceholder": "https://yourwebsite.com",
      "addressPlaceholder": "Katuosoite",
      "streetAddressPlaceholder": "Anna täydellinen osoitteesi",
      "cityPlaceholder": "Anna kaupunki",
      "statePlaceholder": "Anna osavaltiosi",
      "countryPlaceholder": "Anna maasi",
      "postalCodePlaceholder": "Postinumero tai postinumeroalue",
      "organizationPlaceholder": "Anna organisaatiosi"
    },
    "text": {
      "singleLine": "Yksilöllinen Viiva",
      "multiLine": "Moni Viiva",
      "textBoxList": "Teksti Neliö Luettelo",
      "singleLinePlaceholder": "Anna tekstisi",
      "multiLinePlaceholder": "Kirjoita viestisi tähän"
    },
    "choiceElements": {
      "singleDropdown": "Yksilöllinen Pudotus-",
      "multiDropdown": "Moni Pudotus-",
      "checkbox": "Valintaruutu",
      "radio": "Radio-",
      "singleDropdownPlaceholder": "Valitse vaihtoehto",
      "multiDropdownPlaceholder": "Valitse yksi tai useampi vaihtoehto",
      "pictureChoice": {
        "label": "Kuvan valinta",
        "multipleSelection": "Usean valinnan mahdollisuus",
        "selectionTypeLocked": "Valintatyyppiä ei voi muuttaa, kun tämä mukautettu kenttä on tallennettu.",
        "imageRequiredBeforeSave": "Jokaisella Kuvan valinta -elementin vaihtoehdolla on oltava kuva.",
        "labelRequiredBeforeSave": "Jokaisella Picture Choice -elementin vaihtoehdolla on oltava otsikko.",
        "duplicateOptionLabelsBeforeSave": "Jokaisella Picture Choice -elementin vaihtoehdolla on oltava yksilöllinen tunniste.",
        "selectionLimitInvalidBeforeSave": "Anna kelvollinen valintaraja Kuvan valinta -elementille.",
        "selectionLimit": "Valintarajoitus",
        "unlimited": "Rajoittamaton",
        "exact": "Täsmälleen",
        "range": "Väli",
        "exactSelections": "Tarkat valinnat",
        "minimum": "Minimi",
        "maximum": "Maksimi",
        "options": "Vaihtoehdot",
        "optionSettings": "Asetukset",
        "showOptionLabel": "Näytä vaihtoehdon tunniste",
        "addOption": "Lisää vaihtoehto",
        "otherOption": "Muu vaihtoehto",
        "imageFit": "Kuvan sovitus",
        "cover": "Kansi",
        "contain": "Sisältää seuraavan:",
        "fill": "Täyttö",
        "spreadToColumns": "Levitä sarakkeisiin",
        "columns": "Sarakkeet",
        "numberOfColumns": "Sarakkeiden lukumäärä",
        "desktopColumnsLimit": "Enintään {count} saraketta työpöydällä.",
        "mobileColumnsLimit": "Enintään {count} saraketta mobiililaitteella.",
        "otherOptionLabel": "Muu vaihtoehto -nimike",
        "optionLabel": "Vaihtoehdon tunniste",
        "image": "Kuva",
        "media": "Media",
        "otherImageUploadUnavailable": "Muu-vaihtoehdolle ei voi ladata kuvaa.",
        "removeImage": "Poista kuva",
        "deleteOption": "Poista vaihtoehto",
        "altText": "Alt-teksti"
      }
    },
    "customized": {
      "text": "Teksti",
      "html": "Html",
      "htmlPlaceholder": "Mukautettu HTML menee tässä",
      "captcha": "Captcha",
      "captchaDefaultLabel": "Haaste",
      "botProtection": "Bottisuojaus",
      "verificationMode": "Vahvistustila",
      "interactive": "Interaktiivinen",
      "invisible": "Näkymätön",
      "invisibleModeDescription": "Tämä tarkistus suoritetaan automaattisesti taustalla, eikä se ole käyttäjille näkyvissä.",
      "fieldHiddenWarning": "Tämä kenttä on piilotettu eikä sitä näytetä lomakkeella.",
      "verifyHuman": "Varmista, että olet ihminen",
      "privacy": "Tietosuoja",
      "help": "Ohje",
      "captchaPlaceholder": "CAPTCHA",
      "source": "Lähde",
      "termsAndConditions": "T & C",
      "termsAndConditionsPlaceholder": "Hyväksyn ehdot Julkaistu Kautta yritys. Kautta tarjoamalla Puhelinnumeroni, hyväksyn Periä Tekstin viestit – yritys.",
      "score": "Pisteet",
      "scorePlaceholder": "Esimerkki: pisteesi on 100 %"
    },
    "other": {
      "url": "URL",
      "urlPlaceholder": "Anna URL-osoite",
      "image": "Kuva",
      "fileUpload": "Tiedosto Ladata",
      "monetary": "Raha-",
      "number": "luku",
      "datePicker": "Päivämäärä ja kellonaika",
      "datePickerLegacy": "Päivämäärävalitsin",
      "datePickerGeneratedName": "Päivämäärä",
      "timePickerGeneratedName": "Aika",
      "dateTimePickerGeneratedName": "Päivämäärä ja kellonaika",
      "signature": "Allekirjoitus",
      "monetaryPlaceholder": "Anna summa",
      "signaturePlaceholder": "Allekirjoita tähän",
      "numberPlaceholder": "Anna numero",
      "datePickerPlaceholder": "PP / KK / VVVV",
      "imageUploadPlaceholder": "Kuvia ei ole vielä lisätty",
      "imageUploadSubText": "Lähetä mediatallennustilaan tai vedä ja pudota",
      "imageUploadButtonText": "Lataa kuva palvelimeen",
      "fileText": "Tiedosto",
      "fileUploadSupportedFileTypes": "PDF, DOC/DOCX, XLS/CSV, JPG/JPEG, PNG, GIF",
      "fileUploadPlaceholder": "Lataa napsauttamalla"
    },
    "customstyle": "Tyyli",
    "standard": "Vakio",
    "bubble": "Kupla"
  },
  "survey": {
    "addSlideText": "Lisää elementtejä",
    "defaultScreenTitle": "Vedä ja pudota komponentteja",
    "defaultScreenDescription": "Siirrä kysymyksesi {pageIndex} -sivulle vasemmalla olevien elementtien avulla.",
    "typeOfBuilder": "Kysely",
    "survyeStyle": "Kyselyn tyyli",
    "surveyName": "Kyselyn nimi",
    "surveyElement": "Kyselyelementti",
    "addSurveyElement": "Lisää kyselyelementti",
    "cloneSlide": "Kloonaa dia",
    "unsavedAlertMessage": "Kyselyssä on tallentamattomia muutoksia. Haluatko varmasti poistua ja hylätä kaikki tallentamattomat muutokset?",
    "thirdPartyScriptAlertMessage": "HTML-lohkon sisäiset kolmansien osapuolten komentosarjat voivat mahdollistaa käteviä toiminnallisuuksia, mutta niihin liittyy myös tietosuojaa, turvallisuutta, suorituskykyä ja sivun toimintaa koskevia riskejä. Siksi suosittelemme, että tarkistat tämän komentosarjan sisällön ennen kuin tallennat sen kyselyyn.",
    "integrateHeader": "Integroi kysely",
    "integrateSubHeader": "Voit integroida verkkosivustollesi mukautetun kyselytutkimuksen seuraavien vaihtoehtojen avulla.",
    "integrateCopyLinkMessage": "Kopioi alla oleva linkki ja jaa se helposti missä vain.",
    "onSurveySubmission": "Kyselyn lähettämisen yhteydessä",
    "saveExitConfirmation": "Tallenna edistyminen kyselyissä",
    "surveySettings": "Kyselyn asetukset",
    "oneQuestionAtTime": "Yksi kysymys kerrallaan",
    "backButton": "Takaisin-painike",
    "backButtonTooltipMessage": "Takaisin-painike auttaa käyttäjiä siirtymään edelliselle dialle",
    "disableAutoNavigation": "Poista automaattinen navigointi käytöstä",
    "disableAutoNavigationTooltipMessage": "Siirtyy automaattisesti kohtaan Seuraava Liukua Jälkeen a käyttäjä vastaa.",
    "autoNavigation": "Automaattinen navigointi",
    "autoNavigationTooltipMessage": "Siirtyy automaattisesti kohtaan Seuraava Liukua Jälkeen a käyttäjä vastaa.",
    "progressBar": "Edistymispalkki",
    "progressBarTooltipMessage": "Jos poistat tämän käytöstä, edistymispalkki poistetaan kyselystä",
    "disableAnimation": "Poista animaatio käytöstä",
    "disableAnimationTooltipMessage": "Tämän ottaminen käyttöön poistaa dian vaihtumisanimaation käytöstä",
    "scrollToTop": "Vieritä ylös",
    "scrollToTopTooltipMessage": "Jos tämä asetus on käytössä, kysely vieritetään seuraavan dian alkuun",
    "submitSurvey": "Lähetä kysely",
    "disqualifyImmediately": "Hylkää heti",
    "disqualifyAfterSubmit": "Hylkää lähettämisen jälkeen",
    "disqualifyAfterSubmitLowerCase": "Hylkää lähettämisen jälkeen",
    "footerHTML": "Alatunnisteen HTML",
    "footerHTMLMessage": "Voit kirjoittaa mukautettua CSS-koodia (käyttämällä style-tagia) ja HTML-koodia samaan kenttään",
    "editFooter": "Muokkaa alatunnistetta",
    "disqualifySettings": "Hylkää asetukset",
    "disqualifyImmediatelyLabel": "Heti",
    "disqualifyAfterSubmitLabel": "Lähettämisen jälkeen",
    "slideConflictAlertMessage": "Tässä diassa on useita kysymyksiä, joille on määritetty logiikka. Tämä voi johtaa ei-toivottuun toimintaan",
    "addSlide": "Lisää dia",
    "settings": "Asetukset",
    "delete": "Poista",
    "slideDeleteAlertMessage": "Haluatko varmasti poistaa tämän dian?",
    "slideDeleteBetweenAlertMessage": "Tämä järjestää muut diat uudelleen. Haluatko varmasti poistaa tämän dian?",
    "slideLabel": "Dia {n}",
    "slideName": "Dian nimi",
    "slidePosition": "Dian sijainti",
    "jumpTo": "Siirry kohtaan",
    "jumpToSubText": "Siirry tiettyyn diaan",
    "enableTimezoneSurvey": "Tämän vaihtoehdon käyttöönotto tallentaa kyselyyn vastanneen henkilön aikavyöhykettä koskevat tiedot.",
    "footer": {
      "footer": "Alatunniste",
      "enableNewFooter": "Ota uusi alatunniste käyttöön",
      "stickToSurvey": " Pysy kiinni kyselyssä",
      "backgroundFill": "Taustan täyttö",
      "footerHeight": "Alatunnisteen korkeus",
      "enableProgressBar": "Ota edistymispalkki käyttöön",
      "buttons": "Painikkeet",
      "button": "Painike",
      "buttonType": "Painikkeen tyyppi",
      "buttonTypeTooltip": "Valitse, miten navigointipainikkeet näkyvät kyselyn alatunnisteessa",
      "fillNext": "Täytä (seuraava)",
      "fillPrevious": "Täytä (edellinen)",
      "fillSubmit": "Täytä (Lähetä)",
      "textColor": "Painikkeen teksti",
      "position": "Sijainti",
      "positionTooltip": "Valitse, miten navigointipainikkeet näkyvät kyselyn alatunnisteessa",
      "previousText": "Edellinen (teksti)",
      "nextText": "Seuraava (teksti)",
      "submitText": "Lähetä (teksti)",
      "fillComplete": "Täyttöväri – valmis",
      "fillInactive": "Täyttöväri – ei-aktiivinen",
      "footerType": "Alatunnisteen tyyppi",
      "stickToCard": "Pysy kiinni kortissa",
      "stickToPage": "Pysy kiinni sivulla",
      "stepTextColor": "Vaihe Runko Väri",
      "progressBarFill": "Edistymispalkki Täyttää",
      "progressBarInactive": "Edistymispalkki Inaktiivinen",
      "arrowFill": "Nuoli Täyttää",
      "submitColorMobile": "Lähetä (Väri)",
      "arrowFillColor": "Nuoli Täyttää Väri",
      "buttonTypes": {
        "textAndArrow": "Teksti ja nuoli",
        "onlyText": "Vain teksti",
        "onlyArrow": "Vain nuoli"
      },
      "positions": {
        "leftAndRight": "Vasen ja oikea"
      },
      "placeholders": {
        "prev": "Edellinen",
        "next": "Seuraava",
        "submit": "Lähetä"
      }
    },
    "surveyNotfication": "Kyselyilmoitus",
    "style": {
      "surveyPadding": "Kyselyn reunatila"
    },
    "integratePopup": {
      "shareOrEmbed": "Upota tai jaa kysely",
      "share": {
        "openFormLink": "Avata Kysely Linkki"
      },
      "email": {
        "emailSubheader": "Luoda a tyhjä sähköposti ja Upottaa Sinun Kysely, Tai Valita a Mallipohja ja Upottaa it Heti."
      }
    },
    "autoResponderSubheader": "Lähetä automaattinen sähköpostiviesti kyselyyn vastanneelle henkilölle (sähköpostiviesti sisältää kopion kyselyyn lisätyistä vastauksista)",
    "sendSubmissionsAsPdf": "Lähetä kyselyn vastauslähetys PDF-tiedostona",
    "switchToOneQuestionAtTimeOn": "\"One Kysymys päivämäärällä\" -kohdan ottaminen käyttöön häiritsee Tämänhetkinen ehdollista logiikkaa",
    "switchToOneQuestionAtTimeOff": "Poistaa'One Kysymys at a Päivämäärä' vaikuttaa ehdolliseen Logiikka Konfiguraatioon",
    "switchToOneQuestionAtTimeOnWarning": "Jotkin ehdot eivät enää toimi odotetulla tavalla Kun kysymykset ovat Osallistunut yksi päivämäärällä.",
    "switchToOneQuestionAtTimeOffWarning": " Jotkin Yksilöllinen-kysymyksen Virtaukseen suunnitelluista ehdoista lakkaavat toimimasta tarkoitetulla tavalla.",
    "createContactOnPartialSubmissionSubText": "Luo kontaktin, kun käyttäjä napsauttaa ”Seuraava”-painiketta missä tahansa diassa – vaikka hän ei olisi täyttänyt kyselyä loppuun.",
    "dragDrop": {
      "imageLabel": "Kuva {n}",
      "htmlLabel": "HTML {n}",
      "defaultFolderName": "Kysely {'|'} {name}",
      "defaultTermsHtml": "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Tietosuojaseloste</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Käyttöehdot</a></p>",
      "smsConsent": "Suostun vastaanottamaan tekstiviesti-ilmoituksia, hälytyksiä ja satunnaista markkinointiviestintää yritykseltä. Viestin toistumistiheys vaihtelee. Viesti- ja datamaksuja voidaan periä. Lähetä tekstiviesti HELP numeroon (XXX) XXX-XXXX saadaksesi apua. Voitte peruuttaa tilauksen milloin tahansa vastaamalla STOP."
    }
  },
  "form": {
    "typeOfBuilder": "Lomake",
    "formStyle": "Lomakkeen tyyli",
    "formElement": "Lomake-elementti",
    "addFormElement": "Lisää lomake-elementti",
    "addConditionalLogic": "Lisää ehdollinen logiikka",
    "openConditionalLogic": "Avaa ehdollinen logiikka",
    "inlineForm": "Inline-lomake",
    "formName": "Lomakkeen nimi",
    "fullScreenMode": "Koko näytön tila",
    "fullScreenModetooltip": "Kun vaihtoehto on otettu käyttöön, lomake mukautuu koko säiliön leveyteen ja ulottuu upotusalueen reunaan huomioiden samalla lomakkeen leveyden.",
    "enableTimezoneForm": "Tämän vaihtoehdon käyttöönotto tallentaa lomakkeen lähettäneen henkilön aikavyöhykettä koskevat tiedot.",
    "formSettings": "Lomakeasetukset",
    "scheduleVisibility": {
      "title": "Aikatauluta {product} näkyvyys",
      "subtitle": "Määritä, milloin tämän {product} tulisi alkaa ja lopettaa vastausten vastaanottaminen. Tämän ikkunan ulkopuolella vierailijat näkevät alla määrittämäsi viestit.",
      "formOpens": "{Product} avautuu",
      "formCloses": "{Product} sulkeutuu",
      "rightAway": "Välittömästi",
      "never": "Ei koskaan",
      "pickADate": "Valitse päivämäärä",
      "opensPlaceholder": "Avautuu heti, kun julkaiset",
      "closesPlaceholder": "Pysyy auki, kunnes suljet sen",
      "date": "Päivämäärä",
      "time": "Aika",
      "timezone": "Aikavyöhyke",
      "timezoneHelp": "Koskee sekä avaus- että sulkemisaikoja.",
      "timezonePlaceholder": "Valitse aikavyöhyke",
      "timeline": {
        "notOpenYet": "Ei vielä auki",
        "acceptingResponses": "Vastauksia hyväksytään",
        "closed": "Suljettu",
        "current": "Nykyinen",
        "opens": "Avautuu",
        "closes": "Sulkeutuu"
      },
      "whatVisitorsSee": "Mitä vierailijat näkevät",
      "whatVisitorsSeeHelp": "Nämä sivut näkyvät vain avoimen ikkunan ulkopuolella. Valitse tila määrittääksesi sen.",
      "states": {
        "beforeTitle": "Ennen kuin {product} avautuu",
        "afterTitle": "Kun {product} sulkeutuu",
        "showsPage": "Näyttää mukautetun sivun",
        "redirectsTo": "Uudelleenohjaa kohteeseen {url}"
      },
      "showPage": "Näytä sivu",
      "showPageHelp": "Suunnittele, mitä vierailijat näkevät.",
      "openLink": "Avaa linkki",
      "openLinkHelp": "Lähetä heidät toiseen URL-osoitteeseen.",
      "redirectUrl": "Uudelleenohjauksen URL-osoite",
      "redirectUrlPlaceholder": "https://esimerkki.com",
      "redirectUrlHelp": "Tässä tilassa olevat vierailijat ohjataan tänne sen sijaan, että he näkisivät sivun. Käytä täydellistä URL-osoitetta, kuten https://example.com/path.",
      "redirectUrlInvalid": "Anna kelvollinen URL-osoite, joka alkaa etuliitteellä http:// tai https://, kuten https://example.com/path.",
      "defaultBeforeMessage": "Tämä {product} ei ole vielä avoinna",
      "defaultAfterMessage": "Tämä {product} on nyt suljettu",
      "defaultBeforeBody": "Tällä {product} -tuotteella ei vielä vastaanoteta vastauksia. Tarkista tilanne uudelleen, kun se avautuu, ja lähetä vastauksesi.",
      "defaultAfterBody": "Kiitos mielenkiinnostasi! Tämä {product} on lakannut hyväksymästä vastauksia. Voit tarvittaessa ottaa edelleen yhteyttä tuotteen {product} omistajaan.",
      "closeAfterOpenError": "Sulkemisajan on oltava avaamisajan jälkeen.",
      "preview": {
        "label": "Esikatselu",
        "labelHint": "– miten vierailijat näkevät sen",
        "redirectTo": "Sinut uudelleenohjataan tänne:",
        "poweredBy": "Toimistosi tarjoama"
      },
      "appearance": {
        "title": "Ulkoasu",
        "cardBackground": "Kortin tausta",
        "pageBackground": "Sivun tausta",
        "cornerRadius": "Kulman säde",
        "cardWidth": "Kortin leveys",
        "cardHeight": "Kortin korkeus",
        "shadow": "Varjo",
        "autoPlaceholder": "Automaattinen",
        "marginPadding": "Ulko- ja sisämarginaali",
        "auto": "automaattinen",
        "miscellaneous": "Muut",
        "agencyBranding": "Yrityksen brändäys",
        "agencyBrandingHelp": "Näytä toimistosi logo ja nimi suljetun tilan sivuilla.",
        "shadowOptions": {
          "none": "Ei mitään",
          "soft": "Pehmeä",
          "elevated": "Korotettu"
        },
        "colors": {
          "default": "Oletus",
          "lightGray": "Vaaleanharmaa",
          "brandTint": "Brändin sävytys",
          "blush": "Punertava",
          "dark": "Tumma",
          "white": "Valkoinen",
          "coolGray": "Viileän harmaa"
        }
      }
    },
    "saveExitConfirmation": "Tallenna edistyminen lomakkeissa",
    "unsavedAlertMessage": "Lomakkeessa on tallentamattomia muutoksia. Haluatko varmasti poistua ja hylätä kaikki tallentamattomat muutokset?",
    "thirdPartyScriptAlertMessage": "HTML-lohkon sisäiset kolmansien osapuolten komentosarjat voivat mahdollistaa käteviä toiminnallisuuksia, mutta niihin liittyy myös tietosuojaa, turvallisuutta, suorituskykyä ja sivun toimintaa koskevia riskejä. Siksi suosittelemme, että tarkistat tämän komentosarjan sisällön ennen kuin tallennat sen lomakkeeseen.",
    "onFormSubmission": "Lomakkeen lähettämisen yhteydessä",
    "integrateForm": "Integroi lomake",
    "embedlayoutType": "Upottaa Asettelu Kirjoittaa",
    "embedlayoutTypeSubMessage": "Valitse suppiloon tai ulkoiselle verkkosivustolle upotettava asettelu",
    "triggerType": "Käynnistystyyppi",
    "showOnScrolling": "Näytä sivua vieritettäessä",
    "showAfter": "Näytä seuraavan jälkeen:",
    "seconds": "sekuntia",
    "alwaysShow": "Näytä aina",
    "activationOptions": "Aktivointivaihtoehdot",
    "activateOn": "Aina päällä",
    "visit": "vierailu",
    "alwaysActivated": "Aina aktiivisena",
    "deactivationOptions": "Aktivoinnin poistamisvaihtoehdot",
    "deactivateAfterShowing": "Poista aktivointi näyttämisen jälkeen",
    "times": "kertaa",
    "deactiveOnceLeadCollected": "Poista aktivointi, kun liidi on kerätty",
    "neverDeactivate": "Älä poista aktivointia koskaan",
    "copyEmbedCode": "Kopioi upotuskoodi",
    "copyFormLink": "Kopioi lomakkeen linkki",
    "openFormLink": "Avaa lomakkeen linkki",
    "inline": "Inline",
    "inlineDescription": "Inline-lomake näkyy natiivielementtinä osana sivun muuta sisältöä. Se ei avaudu minkään päälle, eikä sitä voi sulkea tai pienentää.",
    "inlineHoverDescription": "Inline-lomake näkyy natiivielementtinä osana sivun muuta sisältöä. Se ei avaudu minkään päälle, eikä sitä voi sulkea tai pienentää.",
    "popup": "Ponnahdusikkuna",
    "popupDescription": "Lomake näkyy sivun sisällön päälle ilmestyvässä lightbox-ponnahdusikkunassa. Sitä ei voi pienentää, mutta sen voi sulkea.",
    "popupHoverDescription": "Lomake näkyy sivun sisällön päälle ilmestyvässä lightbox-ponnahdusikkunassa. Sitä ei voi pienentää, mutta sen voi sulkea.",
    "politeSlideIn": "Liukuikkuna",
    "politeSlideInDescription": "Liukuikkuna liukuu esiin näytön alareunasta ja katoaa suljettaessa",
    "politeSlideInHoverDescription": "Liukuu esiin näytön alareunasta ja katoaa suljettaessa",
    "stickySidebar": "Tahmea sivupalkki",
    "stickySidebarDescription": "Tahmea sivupalkki ilmestyy näytön sivureunaan, ja sen voi pienentää ikkunan sivuun tarttuvaksi välilehdeksi.",
    "stickySidebarHoverDescription": "Ilmestyy näytön sivureunaan; voidaan pienentää ikkunan sivuun tarttuvaksi välilehdeksi.",
    "allowMinimize": "Salli pienentäminen",
    "checkForCookieConsent": "Kunnioita isäntäsivuston evästeiden suostumusta",
    "checkForCookieConsentTooltip": "Pikselitapahtumat laukeavat vasta, kun vierailija hyväksyy markkinointievästeet sivustolla, johon tämä lomake on upotettu. Automaattinen tunnistus etsii seuraavia: GHL-CookieConsent, OneTrust, Cookiebot, Complianz, Usercentrics, TrustArc, Cookieyes, Iubenda, Termly, Osano, Didomi ja IAB TCF.",
    "cookieConsentProvider": "Evästeiden suostumuksen palveluntarjoaja",
    "cookieConsentProviderPlaceholder": "Valitse evästeiden suostumuksen banneri",
    "cookieConsentProviderAutoDetect": "Automaattinen tunnistus",
    "modalHeight": "Modaalin korkeus",
    "modalHeightPlaceholder": "Syötä modaalin korkeus",
    "conditonalLogic": {
      "conditions": "Ehdot",
      "noExistingCondition": "Ehtoja ei ole vielä luotu",
      "freeRoamMessage": "Säännöt eivät rajoita tekemisiäsi – ainakaan vielä",
      "addNewCondition": "Lisää uusi ehto",
      "redirectToUrl": "Uudelleenohjaa URL-osoitteeseen",
      "displayCustomMessage": "Näytä mukautettu viesti",
      "disqualifyLead": "Hylkää liidi",
      "showHideFields": "Näytä/piilota kentät",
      "jumpTo": "Siirry kohtaan",
      "redirectToUrlSubText": "Uudelleenohjaa käyttäjät jälkilähetys",
      "displayCustomMessageSubText": "kaikki viestit perustuvat Päällä käyttäjä inputs",
      "disqualifyLeadSubText": "Suodattaa merkinnät tietyissä olosuhteissa",
      "showHideFieldsSubText": "Muokata Kenttä Näkyvyys dynaamisesti",
      "openBelowUrl": "Avaa alla oleva URL-osoite",
      "showCustomMessage": "Näytä mukautettu viesti",
      "alertConditionDelete": "Haluatko varmasti poistaa tämän ehdon?",
      "deleteCondition": "Poista ehto",
      "conditionExecutedMessage": "Ehdot toteutetaan järjestyksessä ylhäältä alaspäin.",
      "allOperationOptions": {
        "isEqualTo": "On yhtä kuin",
        "isNotEqualTo": "Ei ole yhtä kuin",
        "contains": "Sisältää seuraavan:",
        "doesNotContain": "Ei sisällä",
        "startsWith": "Alkaa seuraavalla:",
        "endsWith": "Päättyy seuraavaan:",
        "isEmpty": "On tyhjä",
        "isFilled": "On täytetty",
        "before": "Ennen seuraavaa:",
        "after": "Seuraavan jälkeen:",
        "greaterThan": "Suurempi kuin",
        "lessThan": "Pienempi kuin",
        "between": "Välillä",
        "isChecked": "On valittu",
        "isNotChecked": "Ei ole valittu"
      },
      "logic": {
        "if": "Jos",
        "then": "Sitten",
        "and": "Ja",
        "or": "Tai"
      },
      "phoneAlertMessage": "Jos haluat hakea maakoodin sisältäviä puhelinnumeroita, sinun on lisättävä hakukyselyyn erikseen +-merkki.",
      "deleteAlertMessage": "Haluatko varmasti poistaa tämän kentän? Myös tähän kenttään liittyvä ehto poistetaan.",
      "deleteField": "Poista kenttä",
      "jumpToDescription": "Siirtykää tiettyyn diaan, kun ehdot täyttyvät",
      "cycleError": "Ei voida tallentaa. Sykli havaittu välillä {a} ja {b}",
      "jumpToSlide": "Siirry diaan",
      "submitSurvey": "Lähetä kysely",
      "pageTitle": "P{index} – {title}",
      "selectSlideToJumpTo": "Valitse dia, jolta siirryt",
      "selectedSlide": "Valittu dia",
      "typeValueHere": "Kirjoita arvo tähän",
      "field": "Kenttä",
      "slide": "Dia",
      "selectFieldOrSlide": "Valitse kenttä tai dia",
      "selectFieldState": "Valitse kentän tila",
      "selectField": "Valitse kenttä",
      "selectOption": "Valitse vaihtoehto",
      "jumpToTarget": "Siirry kohtaan",
      "jumpToQuestion": "Siirry kysymykseen",
      "chooseQuestion": "Valitse kysymys",
      "includeStart": "Sisällytä aloitus",
      "includeEnd": "Sisällytä loppu",
      "includeValue": "Sisällytä {value}",
      "hideField": "Piilota kenttä",
      "hideFields": "Piilota kentät",
      "showField": "Näytä kenttä",
      "showFields": "Näytä kentät",
      "additionalRulesPrefix": "...ja",
      "additionalRulesSuffix": "muut {ifLabel} säännöt ...",
      "shownTargetsWithMore": "{shown}, +{count} lisää",
      "noConditionsAlt": "Ei ehtoja vielä",
      "outcomeLabels": {
        "show": "Näytä",
        "jumpTo": "Siirry kohtaan"
      }
    },
    "minimizedTitlePlaceholder": "Pienennetty otsikko",
    "dragYourElementFromLeft": "Vedä elementtejä tähän vasemmalta",
    "formNotification": "Lomakeilmoitus",
    "sendSubmissionsAsPdf": "Lähetä lomakkeen vastauslähetys PDF-tiedostona",
    "style": {
      "formPadding": "Lomakkeen reunatila"
    },
    "integratePopup": {
      "shareOrEmbed": "Upota tai jaa lomake",
      "share": {
        "openFormLink": "Avata Lomake Linkki"
      },
      "email": {
        "emailSubheader": "Luoda a tyhjä sähköposti ja Upottaa Lomake, Tai Valita a Mallipohja ja Upottaa it Heti."
      }
    },
    "choosePosition": "Valita Tila",
    "testBuild": "Testiversio"
  },
  "quiz": {
    "quizElement": "Tietovisaelementti",
    "quizNotification": "Tietovisailmoitus",
    "viewAndCustomise": "Näytä ja mukauta",
    "categoryAndScore": "Kategoria ja pisteet",
    "provideFeedback": "Anna palautetta",
    "addQuizElement": "Lisää tietovisaelementti",
    "typeOfBuilder": "Tietovisa",
    "addQuestions": "Lisätä kysymyksiä",
    "dragAndDropQuestion": "Vetää ja pudota Kysymys tässä.",
    "addNewPage": "Lisää sivu",
    "editTemplate": "Muokata Mallipohja",
    "editResultPage": "Muokkaa tulossivua",
    "clonePage": "Kloonaa sivu",
    "category": {
      "category": "Kategoria",
      "useCategoryWhen": "Käytä Kategoriat Kunia",
      "manageCategories": "Hallinnoida Kategoriat",
      "howItWorks2": "Miten tämä toimii",
      "addCategoryMessage": "Lisätä uusi Kategoria",
      "assignCategoryMessage": "Määritä Kategoria vaihtoehtoon",
      "editResultsMessage": "tulee Kategoria-pisteet Tulos in",
      "toEvaluateTheResponder": "Vertaillalle vastaaja perustui Päällä useisiin tekijöihin",
      "showMultipleCategoryScore": "siinä useita Kategoria-pisteitä Tulos in",
      "displayVaryingContent": "Näyttö- vaihteleva Sisältö Päällä tulokset Sivu riippuen Päällä Kategoria-tulostaso",
      "addManage": "Lisätä / Hallinnoida",
      "carouselAlt": "Kategorian esikatseludia"
    },
    "quizSettings": "Tietovisan asetukset",
    "saveExitConfirmation": "Tallenna edistyminen tietovisoissa",
    "onQuizSubmission": "Tietovisan lähettämisen yhteydessä",
    "settings": "Asetukset",
    "deletePage": "Poista sivu",
    "quizResult": {
      "resultTemplate": "Tulossivun mallipohja",
      "quizResultAlertMessage": "Valittu tulossivu näytetään, kun tietovisa on suoritettu",
      "overallScoreLabel": "Kokonaispistemäärä",
      "resultTemplateAlt": "Tietovisan tulosmallin esikatselu"
    },
    "deleteSlideMessage": "Haluatko varmasti poistaa tämän dian?",
    "autoResponderSubheader": "Lähetä automaattinen sähköpostiviesti tietovisaan vastanneelle henkilölle (sähköpostiviesti sisältää kopion tietovisaan annetuista vastauksista)",
    "sendSubmissionsAsPdf": "Lähetä tietovisan vastauslähetys PDF-tiedostona",
    "sendQuizResultsAsPdf": "Lähetä tietovisan tulos PDF-tiedostona",
    "integrateHeader": "Integroi tietovisa",
    "integrateSubHeader": "Integroi mukautettu tietovisa verkkosivustolle seuraavien vaihtoehtojen avulla",
    "integrateCopyLinkMessage": "Kopioi alla oleva linkki ja jaa se helposti missä vain.",
    "pageLabel": "Sivu {n}",
    "pageName": "Sivun nimi",
    "pagePosition": "Sivun sijoituspaikka",
    "createContactOnPartialSubmissionSubText": "Luo kontaktin, kun käyttäjä napsauttaa ”Seuraava”-painiketta missä tahansa diassa – vaikka hän ei olisi suorittanut tietovisaa loppuun.",
    "integratePopup": {
      "shareOrEmbed": "Upota tai jaa tietovisa",
      "share": {
        "openFormLink": "Avata Linkki"
      },
      "email": {
        "emailSubheader": "Luoda a tyhjä sähköposti ja Upottaa tietovisasi, Tai Valita a Mallipohja ja Upottaa it Heti."
      }
    }
  },
  "textEditor": {
    "textAlign": "Tekstin kohdistaminen",
    "list": "Luettelo",
    "sourceCode": "Lähdekoodi",
    "resetStyle": "Nollaa tyyli",
    "resetDocumentStyle": "Nollaa asiakirjan tyyli"
  }
}
